// import { languageSelectOptions } from '../config/configLanguage';
// import { translation as translateUtil } from '../util/translation';

// // ================ Action types ================ //
// export const START_TRANSLATION = 'app/translation/START_TRANSLATION';
// export const SET_TRANSLATION = 'app/translation/SET_TRANSLATION';
// export const TRANSLATION_ERROR = 'app/translation/TRANSLATION_ERROR';
// export const INITIATE_TRANSLATION = 'app/translation/INITIATE_TRANSLATION';

// const initialTranslation = Object.keys(languageSelectOptions).reduce((acc, cur) => {
//   acc[cur] = {};
//   return acc;
// }, {});

// // ================ Initial state ================ //
// const initialState = {
//   translations: initialTranslation, // { key: translatedText }
//   isTranslating: false,
//   error: null,
// };

// const mergeTranslations = (lang, oldTranslations, newTranslations) => {
//   oldTranslations[lang] = {
//     ...oldTranslations[lang],
//     ...newTranslations,
//   };
//   return { ...oldTranslations };
// };

// // ================ Reducer ================ //
// export default function reducer(state = initialState, action = {}) {
//   const { type, payload } = action;

//   switch (type) {
//     case START_TRANSLATION:
//       return { ...state, isTranslating: true, error: null };

//     case INITIATE_TRANSLATION:
//       return {
//         ...state,
//         isTranslating: false,
//         error: null,
//         translations: mergeTranslations(payload.lang, state.translations, payload.translations),
//       };

//     case SET_TRANSLATION:
//       return {
//         ...state,
//         isTranslating: false,
//         translations: mergeTranslations(payload.lang, state.translations, payload.translations),
//       };

//     case TRANSLATION_ERROR:
//       return { ...state, isTranslating: false, error: payload };

//     default:
//       return state;
//   }
// }

// // ================ Action creators ================ //
// export const startTranslation = () => ({ type: START_TRANSLATION });
// export const setTranslation = (lang, translations) => ({
//   type: SET_TRANSLATION,
//   payload: { translations, lang },
// });
// export const translationError = error => ({ type: TRANSLATION_ERROR, payload: error });
// export const initiateTranslation = (lang, translations) => ({
//   type: INITIATE_TRANSLATION,
//   payload: { translations, lang },
// });

// // ================ Thunk for translating multiple keys ================ //

// export const translateKeys = (keysObj, targetLang, pageId) => async (dispatch, getState) => {
//   dispatch(startTranslation());
//   try {
//     const { translations: savedTranslations } = getState().translation;
//     const entries = Object.entries(keysObj);
//     const pageTranslation = { ...(savedTranslations?.[targetLang]?.[pageId] || {}) };

//     await Promise.all(
//       entries.map(async ([key, value]) => {
//         if (typeof value !== 'string' || typeof pageTranslation[key] !== 'undefined') {
//           pageTranslation[key] = value;
//           return;
//         }
//         const translated = await translateUtil(value, targetLang);
//         pageTranslation[key] = translated || value;
//         return;
//       })
//     );
//     dispatch(setTranslation(targetLang, { [pageId]: pageTranslation }));
//   } catch (err) {
//     console.error('Translation error:', err);
//     dispatch(translationError(err));
//   }
// };

import { languageSelectOptions } from '../config/configLanguage';
import { translation as translateUtil } from '../util/translation';

const defaultTranslations = Object.keys(languageSelectOptions).reduce((acc, cur) => {
  acc[cur] = {};
  return acc;
}, {});

const storageKeys = 'translations';

const saveToSessionStorage = data => {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(storageKeys, JSON.stringify(data));
};

export const getFrmSessionStorage = () => {
  if (typeof window === 'undefined') {
    return defaultTranslations;
  }
  const savedData = sessionStorage.getItem(storageKeys);
  if (typeof savedData !== 'string') {
    return defaultTranslations;
  }
  try {
    return JSON.parse(savedData);
  } catch (err) {
    return defaultTranslations;
  }
};

// ================ Action types ================ //
export const START_TRANSLATION = 'app/translation/START_TRANSLATION';
export const SET_TRANSLATION = 'app/translation/SET_TRANSLATION';
export const TRANSLATION_ERROR = 'app/translation/TRANSLATION_ERROR';
export const INITIATE_TRANSLATION = 'app/translation/INITIATE_TRANSLATION';
export const INITIALIZE_TRANSLATION = 'app/translation/INITIALIZE_TRANSLATION';

// ================ Initial state ================ //
const initialTranslation =
  getFrmSessionStorage() ||
  Object.keys(languageSelectOptions).reduce((acc, cur) => {
    acc[cur] = {};
    return acc;
  }, {});

const initialState = {
  translations: initialTranslation, // { lang: { pageId: { key: "translated" | { label, value } } } }
  isTranslating: false,
  error: null,
};

// ================ Helpers ================ //
const mergeTranslations = (lang, oldTranslations, newTranslations, pageId) => {
  let updatedPageTranslations = newTranslations;

  if (typeof pageId === 'string') {
    const oldPageTranslations = oldTranslations[lang]?.[pageId] || {};
    updatedPageTranslations = {
      ...newTranslations,
      [pageId]: { ...oldPageTranslations, ...newTranslations[pageId] },
    };
  }

  const updatedTranslations = {
    ...oldTranslations,
    [lang]: {
      ...oldTranslations[lang],
      ...updatedPageTranslations,
    },
  };

  saveToSessionStorage(updatedTranslations);
  return updatedTranslations;
};

// ================ Reducer ================ //
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case START_TRANSLATION:
      return { ...state, isTranslating: true, error: null };

    case INITIATE_TRANSLATION:
      return {
        ...state,
        isTranslating: false,
        error: null,
        translations: mergeTranslations(
          payload.lang,
          state.translations,
          payload.translations,
          payload.pageId
        ),
      };
    case INITIALIZE_TRANSLATION:
      return { ...state, translations: { ...payload } };

    case SET_TRANSLATION:
      return {
        ...state,
        isTranslating: false,
        translations: mergeTranslations(
          payload.lang,
          state.translations,
          payload.translations,
          payload.pageId
        ),
      };

    case TRANSLATION_ERROR:
      return { ...state, isTranslating: false, error: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //
export const startTranslation = () => ({ type: START_TRANSLATION });
export const setTranslation = (lang, translations, pageId) => ({
  type: SET_TRANSLATION,
  payload: { translations, lang, pageId },
});
export const translationError = error => ({ type: TRANSLATION_ERROR, payload: error });
export const initiateTranslation = (lang, translations) => ({
  type: INITIATE_TRANSLATION,
  payload: { translations, lang },
});
export const initializeTranslation = payload => ({ type: INITIALIZE_TRANSLATION, payload });

// ================ Thunk for translating multiple keys ================ //
export const translateKeys = (keysObj, targetLang, pageId, lastFetch) => async (dispatch, getState) => {
  dispatch(startTranslation());
  try {
    const { translations: savedTranslations } = getState().translation;
    const pageTranslation = { ...(savedTranslations?.[targetLang]?.[pageId] || {}) };
    const storedFetchedAt = pageTranslation.__meta?.fetchedAt;

    
    const shouldRefetch =
      lastFetch &&
      storedFetchedAt &&
      new Date(lastFetch).getTime() > new Date(storedFetchedAt).getTime();

    await Promise.all(
      Object.entries(keysObj).map(async ([key, value]) => {
        // Case 1: plain string
        if (typeof value === 'string') {
          if (typeof pageTranslation[key] === 'undefined' || shouldRefetch) {
            const translated = await (value
              ? translateUtil(value, targetLang)
              : Promise.resolve(value));
            pageTranslation[key] = translated || value;
          }
          return;
        }

        // Case 2: object with label & value
        if (typeof value === 'object' && value !== null) {
          const result = {};

          if (value.label) {
            result.label =
              !shouldRefetch && pageTranslation[key]?.label
                ? pageTranslation[key].label
                : (await translateUtil(value.label, targetLang)) || value.label;
          }

          if (value.value) {
            result.value =
              !shouldRefetch && pageTranslation[key]?.value
                ? pageTranslation[key].value
                : (await translateUtil(value.value, targetLang)) || value.value;
          }

          pageTranslation[key] = result;
        }
      })
    );

    // Update fetchedAt if we successfully translated or if we are just setting it for the first time
    if (lastFetch) {
      pageTranslation.__meta = { ...pageTranslation.__meta, fetchedAt: lastFetch };
    } else if (!pageTranslation.__meta?.fetchedAt) {
      // If no lastFetch provided but also no stored fetchedAt, maybe set current time?
      // For now, only update if lastFetch is explicitly provided or we want to track it.
      // Let's stick to using lastFetch if provided, otherwise preserve existing or ignore.
      // Actually, if we just fetched fresh data, we might want to stamp it if we had a source of truth.
      // But adhering to the requirement: "send the lastfetch so that i can check"
    }

    dispatch(setTranslation(targetLang, { [pageId]: pageTranslation }, pageId));
  } catch (err) {
    dispatch(translationError(err));
  }
};
